import type { HtmlDataConfig } from '@/types';

const htmlData = {
  metaDescription:
    'Ihr Weg zum unbefristeten Aufenthaltstitel. Prüfen Sie jetzt unverbindlich auf rightmart.de ob Sie die Voraussetzungen für eine uneingeschränkte Aufenthaltserlaubnis oder den deutschen Pass erfüllen!',
  domainName: 'www.rightmart.de',
  trackJsToken: '62fe293f90284011bb0b964f50fb0872',
  trackJsApplicationName: 'pex-lp',
  funnelType: '',
  htmlTitle: 'rightmart.de',
  gtmContainerId: 'N2GH4J9',
  cmpId: '1543b25ad17e5',
  seo: '<div>Ihr Weg zum unbefristeten Aufenthaltstitel. Prüfen Sie jetzt unverbindlich auf rightmart.de ob Sie die Voraussetzungen für eine uneingeschränkte Aufenthaltserlaubnis oder den deutschen Pass erfüllen!</div>',
  convertProjectId: '',
} satisfies HtmlDataConfig as HtmlDataConfig;

export default htmlData;
